import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { change, formValueSelector } from 'redux-form'

import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'
import { FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src'
import getValuesFromQuery from '@cinch/oxd-containers/dealer-listing-filters/src/get-values-from-query'
import { selectors as profileSelectors } from '@cinch/oxd-redux/profile/src'
import { getDelivery } from '@cinch/oxd-redux/profile/src/selectors'

import Select from '../components/sort-select'

const mapStateToProps = (state: any) => {
  const selector = formValueSelector(FORM_NAME)
  const value = selector(state, 'sortingCriteria') as Cinch.FilterFormData['sortingCriteria']
  const urlQuery = getValuesFromQuery() as any
  const hasUrlQuery = Object.keys(urlQuery).length
  const deliveryOption = hasUrlQuery ? urlQuery.deliveryOption : getDelivery(state)
  const location = hasUrlQuery ? urlQuery.location : profileSelectors.getLocation(state).location
  const isDistanceDisabled = !location || deliveryOption === DELIVERY_OPTION.DELIVERY
  const options = [
    {
      selected: {
        sort: 'Price',
        order: 'High - Low',
      },
      label: 'Price high - low',
      value: 0,
    },
    {
      selected: {
        sort: 'Price',
        order: 'Low - High',
      },
      label: 'Price low - high',
      value: 1,
    },
    {
      selected: {
        sort: 'Distance',
        order: 'Closest first',
      },
      label: 'Distance closest first',
      value: 3,
      disabled: isDistanceDisabled,
    },
  ]

  return {
    value: typeof value !== 'number' ? 1 : value,
    options,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  onChange: (value: { target: { value: string } }) => {
    dispatch(change(FORM_NAME, 'sortingCriteria', parseInt(value.target.value, 10)))
  },
})

const Component: React.FC<any> = ({ isFixed = false, value, onChange, options }) => (
  <Select
    isFixed={isFixed}
    selectSize={'regular'}
    meta={{}}
    input={
      {
        'aria-label': 'Sort results',
        name: 'sortingCriteria',
        value,
        onChange,
        onFocus: () => null,
        onBlur: () => null,
      } as any
    }
    options={options}
  />
)

export default connect(mapStateToProps, mapDispatchToProps)(Component)
